module.exports = __webpack_public_path__ + "static/media/ic-arrow-back.b3aa4051.svg";